
import { defineComponent, PropType } from 'vue';

export type SkeletonType = 'table' | 'card' | 'horizontalCard' | 'input';

export default defineComponent({
  name: 'SSkeleton',
  props: {
    type: {
      type: String as PropType<SkeletonType>,
      default: 'card',
    },
  },
});
